import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { UPDATE_MERCHANT } from './consts/types';

export const updateMerchant = createTaskAction(
  UPDATE_MERCHANT,
  undefined,
  task => task.merchantId,
);
